<template>
  <b-card-body>
    <h5>{{ $t('question') }}</h5>
    <div v-for="alternative in question.alternatives" :key="alternative.id">
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input v-model="question.value1" class="input"></b-form-input>
            <b-form-select v-model="alternative.value1" :options="options" />
            <b-form-input v-model="question.value2" class="input"></b-form-input>
            <b-form-select v-model="alternative.value2" :options="options" />
            <b-form-input v-model="question.value3" class="input"></b-form-input>
            <b-form-input v-model="equals" readonly />
            <b-form-input v-model="question.value4" class="input"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button ref="deleteQuestionButton"
            variant="danger"
            style="margin-top: 5px;"
            @click.stop="$emit('onDeleteQuestion', questionIndex)"
            v-if="isPartOfCollection">
            {{ $t('privatePage.scaleQuestionsDelete') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'gnum-module',
  data() {
    return {
      options: [
        { value: '+', text: '+' },
        { value: '-', text: '-' },
        { value: '*', text: '*' },
        { value: '/', text: '/' },
        { value: '=', text: '=' }
      ],
      equals: '='
    }
  },
  props: {
    question: {},
    questionIndex: 0,
    isPartOfCollection: false
  },
  methods: {
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
    }
  }
}
</script>

<style scoped>
.modalButton {
  width: 100%;
  margin: 15px 0px 15px 0px;
}
.input {
  text-align: center;
}
</style>
